import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Modal, Card, Row, Col, FormGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { isEmpty, cloneDeep, set } from 'lodash';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import * as customAction from '../../RangePlan/CustomSections/store/CustomSections.action';
import * as devOrderAction from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import * as action from '../store/OprationalCP.action';
import BtnDelete from '../../../Components/Utility/FilterAction/BtnDelete';
import {
  customStyles,
  columTypeList,
  LocationList,
  poTypeList,
  complitionTypeList,
  manualTypeList,
  manualLabelColours,
  manualStatusColours,
  checkIsNumber,
  RightsAccess,
} from '../../../Components/helper';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import RenderOptionsItem from '../../ProductCP/Modals/RenderOptionsItem';
import RenderLabelOptions from '../../ProductCP/Modals/RenderLabelOptions';
import Loader from '../../../Components/Utility/Loader/Loader';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

function AddEditRow({ isProductArchived, open, toggle, editData, addEditState }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { id } = useParams();
  const { TestingRight } = RightsAccess();
  const [LocationListData, setLocationList] = useState(LocationList);

  useEffect(() => {
    if (!TestingRight) {
      const filterList = LocationList.filter((res) => res._id !== 'testing');
      setLocationList(filterList);
    }
  }, [TestingRight]);

  const valueFromSource = (ele, key) => {
    if (ele[key]) {
      ele.source[key] = { name: ele?.[key]?.name, value: ele?.[key]?._id };
    }
  };

  const manualRemoval = (ele) => {
    if (['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(ele?.manualType?.key)) {
      delete ele?.labelColoursOptions;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.colourCoding;
      delete ele?.status;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Label') {
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.status;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Status') {
      ele.status = ele?.statusColoursOptions.find((colSt) => colSt?.colourHexCode === ele?.status?.colourHexCode);
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.labelColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Textbox') {
      delete ele?.status;
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.labelColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.statusColoursOptions;
    } else {
      delete ele?.options;
      delete ele?.labelColoursOptions;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.status;
      delete ele?.characterLimit;
    }
  };

  const forRowSequence = (ele, i) => {
    return addEditState.Rows.findIndex((e) => e?._id === ele?._id) !== -1
      ? addEditState.Rows.findIndex((e) => e?._id === ele?._id)
      : addEditState.Rows.length + i;
  };

  const addUpdateRow = async (e) => {
    const updatedarr = cloneDeep(e);
    const hasNonUniqueNames = updatedarr.some((item, index) => updatedarr.filter((el, i) => el.name === item.name && index !== i).length > 0);
    if (hasNonUniqueNames) {
      toasterMsg('Please add uniqe row Names', 'danger');
    } else {
      const updatedArray = await updatedarr.map((ele, i) => {
        delete ele?.hasError;
        delete ele?.nameCount;
        ele.operationalCPId = id;
        ele.assignee = ele.assignee?._id || null;
        ele.rowType = ele.rowType?._id;
        ele.source = {
          location: { name: ele?.location?.name, value: ele?.location?._id },
        };
        delete ele.location;
        valueFromSource(ele, 'subLocation');
        delete ele.subLocation;
        valueFromSource(ele, 'locationType');
        delete ele.locationType;
        valueFromSource(ele, 'subType');
        delete ele.subType;
        valueFromSource(ele, 'section');
        if (ele.rowType === 'manual') {
          manualRemoval(ele);
          delete ele?.source;
          delete ele?.subType;
          delete ele?.subLocation;
          delete ele?.locationType;
        }
        if (ele.rowType === 'source') {
          delete ele?.status;
          delete ele?.characterLimit;
          delete ele?.labelColoursOptions;
          delete ele?.options;
          delete ele?.statusColoursOptions;
        }
        ele.sequence = ele.sequence ? ele?.sequence : forRowSequence(ele, i);
        return ele;
      });

      const insertObj = {
        rows: cloneDeep(updatedArray),
        operationalCPId: id,
      };
      if (e?.[0]?._id) {
        insertObj._id = e?.[0]?._id;
      }
      const res = await dispatch(action.addRowsToCard(insertObj, t));
      if (res) {
        await dispatch(action.getRowsForCard(id));
        toggle();
      }
      return true;
    }
  };

  const {
    Users: { userGroupsCardList, logInRights },
    SystemMastersDetails: { customAttributeList, otherSamplesList, sample_tracking },
    customSectionData: { customColumnList, customSectionList },
    UserDetails: { userInfo },
    Measuremets: { mainSamples },
  } = useSelector((reducer) => reducer);
  const loggedInUserId = userInfo?.userId;
  const { CheckActionPermission } = useComponent();

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');

  const [modalState, setModalState] = useState({
    cards: [
      {
        name: '',
        assignee: null,
        nameCount: 0,
        hasError: false,
        rowType: null,
        location: null,
        subLocation: null,
        locationType: null,
        subType: null,
        section: null,
        manualType: null,
        options: [{ name: '' }],
        labelColoursOptions: manualLabelColours,
        status: null,
        statusColoursOptions: manualStatusColours,
        isStatusEditTrue: false,
        characterLimit: '',
      },
    ],
    customColumnList: [],
    asigneeList: [],
    loading: false,
    contentLoading: false,
    subTypeList: [],
  });

  useEffect(() => {
    const manualColumnList = customColumnList?.columns?.filter((column) => column.columnType === 'manual');
    setModalState((oldState) => ({
      ...oldState,
      customColumnList: manualColumnList,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customColumnList, editData]);

  useEffect(() => {
    const initialCall = async () => {
      setModalState((oldState) => ({ ...oldState, loading: true }));
      const res = await Promise.all([
        dispatch(customAction.fetchCustomSectionList()),
        dispatch(systemMasterAction.getCustomAttributeFreeText({ isActive: true })),
        dispatch(
          devOrderAction.getMainSamples({
            loggedInUserId,
            isActive: true,
          }),
        ),
        dispatch(
          systemMasterAction.getOtherSamplesDetails({
            loggedInUserId,
            isActive: true,
          }),
        ),
        dispatch(systemMasterAction.getSampleTrackingDetails()),
        dispatch(action.fetchSuppliers()),
      ]);

      res && setModalState((oldState) => ({ ...oldState, loading: false }));
    };
    initialCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    setModalState((oldState) => ({
      ...oldState,
      subTypeList: [{ name: 'Due Date', _id: 'due_date' }, ...sample_tracking],
    }));
  }, [sample_tracking]);

  useEffect(() => {
    if (!isEmpty(userGroupsCardList)) {
      setModalState((oldState) => ({
        ...oldState,
        asigneeList: [...userGroupsCardList],
      }));
    }
  }, [userGroupsCardList]);

  useEffect(() => {
    const cust = async () => {
      if (editData?.source?.location?.value === 'product_listings') {
        setModalState((oldState) => ({ ...oldState, contentLoading: true }));
        const result = await dispatch(customAction.fetchCustomColumnList(editData?.source?.section));
        result && setModalState((oldState) => ({ ...oldState, contentLoading: false }));
      }
    };
    cust();
  }, [editData, dispatch]);

  const findOrNull = (value) => {
    return value || null;
  };

  useEffect(() => {
    if (editData && userGroupsCardList) {
      setModalState((previousData) => ({
        ...previousData,
        cards: [
          {
            ...editData,
            assignee: userGroupsCardList.find((e) => e?._id === editData?.assignee),
            nameCount: editData?.name?.length,
            rowType: columTypeList.find((e) => e?._id === editData?.rowType),
            manualType: editData?.manualType,
            options: editData?.options || [{ name: '' }],
            labelColoursOptions: editData?.labelColoursOptions || manualLabelColours,
            status: findOrNull(editData?.status),
            statusColoursOptions: editData?.statusColoursOptions || manualStatusColours,
            characterLimit: editData?.characterLimit || '',
            location:
              typeof editData?.source?.location === 'object'
                ? {
                    name: editData?.source?.location?.name,
                    _id: editData?.source?.location?.value,
                  }
                : customSectionList.find((ele) => ele?._id === editData?.source?.location),
            subLocation:
              fromSectionSide(editData, 'location')?.value === 'product_listings'
                ? customColumnList?.columns
                    .filter((ele) => ele?._id === editData?.source?.subLocation)
                    .map((element) => {
                      return { label: element?.title, value: element?._id };
                    })[0]
                : subLocationOptions()?.find((ele) => ele?._id === editData?.source?.subLocation),
            locationType: findOrNull(
              ((fromSectionSide(editData, 'location')?._id || fromSectionSide(editData, 'location')?.value) === 'completion_indicators'
                ? complitionTypeList
                : poTypeListChnages(editData)
              )?.find((ele) => ele?._id === (editData?.source?.locationType?.value || editData?.source?.locationType)),
            ),
            subType: findOrNull(modalState.subTypeList?.find((ele) => ele?._id === editData?.source?.subType?.value)),
            section: findOrNull(customSectionList?.find((ele) => ele?._id.toString() === editData?.source?.section?.toString())),
          },
        ],
        customColumnList: customColumnList?.columns?.filter((column) => column.columnType === 'manual'),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, userGroupsCardList, customAttributeList, poTypeList, mainSamples, otherSamplesList, customColumnList, customSectionList]);

  const addCard = () => {
    const updatedCardArray = [...modalState.cards];
    updatedCardArray.push({
      name: '',
      assignee: null,
      nameCount: 0,
      hasError: false,
      rowType: null,
      location: null,
      subLocation: null,
      locationType: null,
      subType: null,
      section: null,
      manualType: null,
      options: [{ name: '' }],
      labelColoursOptions: manualLabelColours,
      status: null,
      statusColoursOptions: manualStatusColours,
      isStatusEditTrue: false,
      characterLimit: '',
    });
    setModalState((oldState) => ({ ...oldState, cards: updatedCardArray }));
  };

  const deleteCard = (index) => {
    const updatedCards = [...modalState.cards];
    updatedCards.splice(index, 1);
    setModalState((oldState) => ({ ...oldState, cards: updatedCards }));
  };

  const elseOnChnage = (fromInput, newCards, i, name, preValue, nullList, e) => {
    if (fromInput) {
      newCards[i][name] = preValue || e?.target?.value;
    } else {
      nullList?.forEach((element) => {
        if (element === 'options') {
          newCards[i][element] = [{ name: '' }];
        } else if (element === 'labelColoursOptions') {
          newCards[i][element] = manualLabelColours;
        } else if (element === 'statusColoursOptions') {
          newCards[i][element] = manualStatusColours;
          newCards[i].status = null;
        } else {
          newCards[i][element] = null;
        }
      });
      newCards[i][name] =
        name === 'subLocation' && (newCards[i]?.location?._id === 'product_listings' || newCards[i]?.location?._id === 'coasting_information')
          ? { name: e?.label, _id: e?.value }
          : e;
    }
  };

  const fromSectionSide = (cardEle, ele) => {
    return cardEle?.[ele] || cardEle?.source?.[ele];
  };

  const onChange = async (e, name, i, fromInput, preValue, nullList) => {
    const newCards = [...modalState.cards];
    if (name === 'name') {
      newCards[i].name = e;
      newCards[i].nameCount = e.length;
    } else {
      elseOnChnage(fromInput, newCards, i, name, preValue, nullList, e);
    }
    newCards[i].hasError = false;
    if (newCards[i]?.location?._id === 'product_listings' && name === 'section') {
      setModalState((oldState) => ({
        ...oldState,
        contentLoading: true,
      }));
      const res = await dispatch(customAction.fetchCustomColumnList(e?._id));
      res &&
        setModalState((oldState) => ({
          ...oldState,
          contentLoading: false,
        }));
    }
    setModalState((oldState) => ({ ...oldState, cards: newCards }));
  };

  const toCheckInvalue = (arrEle, name) => {
    return fromSectionSide(arrEle, name)?._id || fromSectionSide(arrEle, name)?.value;
  };

  const checkingColourSelection = (arrEle) => {
    return arrEle?.labelColoursOptions?.filter((e) => isEmpty(e?.colourHexCode)).length > 0;
  };

  const manualValidation = (arrEle) => {
    const manualRow = typeof arrEle?.rowType === 'object' ? arrEle?.rowType?._id === 'manual' : arrEle?.rowType === 'manual';
    return (
      (manualRow && !arrEle?.manualType?.key) ||
      (manualRow &&
        arrEle?.manualType?.key === 'Label' &&
        (arrEle?.labelColoursOptions?.filter((e) => e?.isLabelColourChecked).length === 0 || checkingColourSelection(arrEle))) ||
      (manualRow && arrEle?.manualType?.key === 'Status' && (!arrEle?.status || !arrEle?.statusColoursOptions)) ||
      (manualRow && arrEle?.manualType?.key === 'Textbox' && !arrEle?.characterLimit) ||
      (manualRow &&
        ['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(arrEle?.manualType?.key) &&
        !arrEle.options?.[0]?.name?.trim().length > 0)
    );
  };

  const validatingIFCondition = (arrEle) => {
    return (
      !arrEle?.name?.trim().length ||
      !arrEle.rowType ||
      manualValidation(arrEle) ||
      (fromSectionSide(arrEle, 'rowType')?._id === 'source' && !arrEle.location) ||
      checkingWithLocation(arrEle) ||
      (toCheckInvalue(arrEle, 'rowType') === 'manul' && !arrEle.manualType)
    );
  };

  const checkingWithLocation = (arrEle) => {
    return (
      (arrEle.location &&
        (fromSectionSide(arrEle, 'location')?._id === 'product_information' || fromSectionSide(arrEle, 'location')?._id === 'product_listings') &&
        !arrEle.subLocation) ||
      (['samples', 'completion_indicators', 'purchase_orders'].includes(toCheckInvalue(arrEle, 'location')) && !arrEle.locationType) ||
      (arrEle.locationType && toCheckInvalue(arrEle, 'location') === 'samples' && !arrEle.subType) ||
      (toCheckInvalue(arrEle, 'location') === 'product_listings' && !arrEle.section)
    );
  };

  const handleSubmit = async () => {
    const array = cloneDeep(modalState.cards);
    const checkArray = array.filter((ele) => validatingIFCondition(ele));
    if (!checkArray || (checkArray && isEmpty(checkArray))) {
      setModalState((oldState) => ({ ...oldState, loading: true }));
      const res = await addUpdateRow(array);
      if (res) {
        setModalState((oldState) => ({ ...oldState, loading: false }));
      }
    } else {
      const errIds = isEmpty(checkArray) ? [] : checkArray.map((e) => e?._id);
      const updatedArray = array.map((arrEle) => {
        if (errIds.includes(arrEle?._id)) {
          arrEle.hasError = true;
        }
        return arrEle;
      });

      setModalState((oldState) => ({ ...oldState, cards: updatedArray }));
    }
  };

  const poTypeListChnages = (cardEle) => {
    return (fromSectionSide(cardEle, 'location')?._id || fromSectionSide(cardEle, 'location')?.value) === 'purchase_orders'
      ? poTypeList
      : [...mainSamples, ...otherSamplesList];
  };

  const handleCancel = () => {
    toggle();
  };

  const subLocationOptions = () => {
    return customAttributeList
      .filter((e) => {
        if (e.type === 'dropdown' || e.type === 'radio-button') return e?.isLable;
        if (e.type === 'text') return !e?.isLable;
        if (e.type === 'date-picker') return true;
        return false;
      })
      .map((element) => {
        return { label: element?.keyName, value: element?._id };
      });
  };

  const chcekingFromDynamicArray = (array, mainObj) => {
    return typeof mainObj === 'object'
      ? array.find((ele) => (ele?._id || ele?.value) === (mainObj?._id || mainObj?.value))
      : array.find((ele) => (ele?._id || ele?.value) === mainObj);
  };

  const chcekingFromDynamicArrayManual = (array, mainObj) => {
    return typeof mainObj === 'object'
      ? array.find((ele) => (ele?.key || ele?.value) === (mainObj?.key || mainObj?.value))
      : array.find((ele) => (ele?.key || ele?.value) === mainObj);
  };

  const chcekingValueExists = (ele, property, name) => {
    return typeof ele?.[property] === 'object' ? ele?.[property]?._id === name : ele?.[property] === name;
  };

  const typeCondition = (cardEle) => {
    return fromSectionSide(cardEle, 'location')?._id === 'completion_indicators' ? complitionTypeList : poTypeListChnages(cardEle);
  };

  const customColumnListOPtions = useMemo(() => {
    return customColumnList?.columns?.filter((val) => {
      let flag = false;
      if (val?.columnType === 'manual' && (val?.type === 'Number' || val?.type === 'Number_percentage')) {
        flag = true;
      }
      return flag;
    });
  }, [customColumnList?.columns]);

  const moveOption = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.options, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewOptions = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.push({ name: '' });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleOptionChange = (value, index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options[index].name = value;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const removeOption = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderOptionsList = useCallback(
    (option, optionIndex, cardEle, cardIndex) => {
      return (
        <RenderOptionsItem
          column={option}
          index={optionIndex}
          parentIndex={cardIndex}
          moveCard={moveOption}
          id={`${cardEle?._id}_${option?.Nmae}_${optionIndex}_${cardIndex}`}
          remove={removeOption}
          addNew={addNewOptions}
          handleChange={handleOptionChange}
          cardEle={cardEle}
          wholeArry={cardEle?.options}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );

  const moveLabel = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.labelColoursOptions, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewlabels = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.push({
      colourHexCode: '',
      colourName: '',
    });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleLabelChange = (value, index, parentIndex, key) => {
    const copyState = cloneDeep(modalState?.cards);
    set(copyState, `[${parentIndex}].labelColoursOptions[${index}][${key}]`, value);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const removelabel = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderlabelList = useCallback(
    (label, labelIndex, cardEle, cardIndex) => {
      return (
        <RenderLabelOptions // label Item changes
          column={label}
          index={labelIndex}
          parentIndex={cardIndex}
          moveCard={moveLabel}
          id={`${cardEle?._id}_${label?.Nmae}_${labelIndex}_${cardIndex}`}
          removeLabel={removelabel}
          addNewLabel={addNewlabels}
          handleChange={handleLabelChange}
          cardEle={cardEle}
          wholeArry={cardEle?.labelColoursOptions}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );

  const changeStatusArray = (e, cardIndex, keyIn, keyName) => {
    onChange(e.target.value, `statusColoursOptions[${keyIn}][${keyName}]`, cardIndex);
  };

  const sourceOptions = (cardEle, cardIndex) => {
    return (
      chcekingValueExists(cardEle, 'rowType', 'source') && (
        <>
          <Col lg={12} className="mb-3">
            <label className="asterisk-req f-14 mb-0">
              {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.LOCATION')} <span>*</span>
            </label>
            <Select
              name="location"
              options={LocationListData} // locationList
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option._id}`}
              maxMenuHeight={140}
              value={cardEle?.location ? chcekingFromDynamicArray(LocationList, fromSectionSide(cardEle, 'location')) : null}
              styles={customStyles}
              onChange={(e) => onChange(e, 'location', cardIndex, false, null, ['section', 'subLocation', 'locationType', 'subType'])}
              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_LOCATION')}
            />
            {cardEle?.hasError && !cardEle.location && <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.LOCATION_REQUIRED')}</span>}
          </Col>
          {fromSectionSide(cardEle, 'location')?._id === 'product_listings' && (
            <Col lg={12} className="mb-3">
              <label className="asterisk-req f-14 mb-0">
                {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SECTION')} <span>*</span>
              </label>
              <Select
                name="Section"
                options={customSectionList}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={cardEle?.section ? chcekingFromDynamicArray(customSectionList, fromSectionSide(cardEle, 'section')) : null}
                maxMenuHeight={140}
                styles={customStyles}
                onChange={(e) => onChange(e, 'section', cardIndex, false, null, ['subLocation'])}
                placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_SECTION')}
              />
              {cardEle?.hasError && !cardEle.section && <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SECTION_REQUIRED')}</span>}
            </Col>
          )}
          {fromSectionSide(cardEle, 'location') &&
            (fromSectionSide(cardEle, 'location')?._id === 'product_information' ||
              (fromSectionSide(cardEle, 'location')?._id === 'product_listings' && cardEle.section)) && (
              <Col lg={12} className="mb-3">
                <label className="asterisk-req f-14 mb-0">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SUB_LOCATION')} <span>*</span>
                </label>
                <Select
                  name="subLocation"
                  options={
                    cardEle?.location?._id === 'product_listings'
                      ? customColumnListOPtions?.map((ele) => {
                          return {
                            label: ele?.title,
                            value: ele?._id,
                          };
                        })
                      : subLocationOptions()
                  }
                  value={
                    cardEle?.location?._id === 'product_listings'
                      ? customColumnListOPtions
                          ?.map((ele) => {
                            return {
                              label: ele?.title,
                              value: ele?._id,
                            };
                          })
                          ?.find((ele) => ele.value === (fromSectionSide(cardEle, 'subLocation')?.value || fromSectionSide(cardEle, 'subLocation')?._id))
                      : subLocationOptions().find((ele) => {
                          return ele.value === (fromSectionSide(cardEle, 'subLocation')?.value || fromSectionSide(cardEle, 'subLocation'));
                        }) || null
                  }
                  isLoading={modalState.contentLoading}
                  maxMenuHeight={140}
                  styles={customStyles}
                  onChange={(e) => onChange(e, 'subLocation', cardIndex)}
                  placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_SUB_LOCATION')}
                />
                {cardEle?.hasError && !cardEle.subLocation && (
                  <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SUB_LOCATION_REQUIRED')}</span>
                )}
              </Col>
            )}
          {['samples', 'completion_indicators', 'purchase_orders'].includes(fromSectionSide(cardEle, 'location')?._id) && (
            <Col lg={12} className="mb-3">
              <label className="asterisk-req f-14 mb-0">
                {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.TYPE')}
                <span>*</span>
              </label>
              <Select
                name="locationType"
                options={typeCondition(cardEle)}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={
                  cardEle?.locationType || cardEle?.source?.locationType
                    ? chcekingFromDynamicArray(typeCondition(cardEle), fromSectionSide(cardEle, 'locationType'))
                    : null
                }
                maxMenuHeight={140}
                styles={customStyles}
                onChange={(e) => onChange(e, 'locationType', cardIndex, false, null, ['subType'])}
                placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_TYPE')}
              />
              {cardEle?.hasError && !cardEle.locationType && <span className="error-message">Type is required.</span>}
              {fromSectionSide(cardEle, 'location')?._id === 'purchase_orders' && (
                <span className="error-message px-1">
                  <b>{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.NOTE')}</b> {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.PERCENTAGE_APPROVAL')}
                </span>
              )}
            </Col>
          )}
          {fromSectionSide(cardEle, 'locationType') && fromSectionSide(cardEle, 'location')?._id === 'samples' && (
            <Col lg={12} className="mb-3">
              <label className="asterisk-req f-14 mb-0">
                {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SUB_TYPE')} <span>*</span>
              </label>
              {
                <Select
                  name="subType"
                  options={modalState.subTypeList} // subTypeList
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  value={cardEle?.subType ? chcekingFromDynamicArray(modalState.subTypeList, fromSectionSide(cardEle, 'subType')) : null}
                  styles={customStyles}
                  maxMenuHeight={140}
                  onChange={(e) => onChange(e, 'subType', cardIndex)}
                  placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_SUB_TYPE')}
                />
              }

              {cardEle?.hasError && !cardEle?.subType && <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SUB_TYPE_REQUIRED')}</span>}
              {fromSectionSide(cardEle, 'location')?._id === 'samples' && (
                <span className="error-message px-1">
                  <b>{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.NOTE')}</b> {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SUB_TYPE_MESSAGE')}
                </span>
              )}
            </Col>
          )}
        </>
      )
    );
  };

  const manualOptions = (cardEle, cardIndex) => {
    return (
      chcekingValueExists(cardEle, 'rowType', 'manual') && (
        <>
          <Col lg={12} className="mb-3">
            <label className="asterisk-req f-14 mb-0">
              {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.MANUAL_TYPE')} <span>*</span>
            </label>
            <Select
              name="manualType"
              options={manualTypeList}
              getOptionLabel={(option) => `${option.type}`}
              getOptionValue={(option) => `${option.key}`}
              value={cardEle.manualType ? chcekingFromDynamicArrayManual(manualTypeList, fromSectionSide(cardEle, 'manualType')) : null}
              maxMenuHeight={140}
              isDisabled={editData}
              styles={customStyles}
              onChange={(e) => onChange(e, 'manualType', cardIndex, false, null, ['location', 'section', 'subLocation', 'locationType', 'subType'])}
              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_ROW')}
              isLoading={modalState.loading}
            />
            {cardEle?.hasError && !cardEle.manualType && <span className="error-message">Manual Type is required.</span>}
          </Col>
          {['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(cardEle?.manualType?.key) && (
            <DndProvider backend={HTML5Backend} key={`option_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
              <Col lg={12} className="mb-3">
                <label className="asterisk-req f-14 mb-0">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.MANUAL_TYPE_OPTIONS')} <span>*</span>
                </label>
                {cardEle?.options?.map((optionEle, optionIndex) => {
                  return renderOptionsList(optionEle, optionIndex, cardEle, cardIndex);
                })}
              </Col>
            </DndProvider>
          )}
          {cardEle?.manualType?.key === 'Label' && (
            <DndProvider backend={HTML5Backend} key={`label_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
              <Col lg={12} className="mb-3">
                <label className="asterisk-req f-14 mb-0">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.MANUAL_TYPE_LABEL')} <span>*</span>
                </label>
                {cardEle?.labelColoursOptions?.map((labelEle, labelIndex) => {
                  return renderlabelList(labelEle, labelIndex, cardEle, cardIndex);
                })}
              </Col>
              {cardEle.hasError && cardEle?.labelColoursOptions?.filter((e) => e?.isLabelColourChecked).length === 0 && (
                <span className="error-message align-item-center justify-content-center d-flex">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.PLEASE_SELECT_ONE_LABEL')}
                </span>
              )}
              {cardEle.hasError && checkingColourSelection(cardEle) && (
                <span className="error-message align-item-center justify-content-center d-flex">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.PLEASE_SELECT_PROPER_COLOUR')}
                </span>
              )}
            </DndProvider>
          )}
          {cardEle?.manualType?.key === 'Status' && (
            <Col lg={{ span: 6, offset: 3 }} className="mb-3">
              <FormGroup className="m-0">
                <div className="input-group form-floating-label fixed-label">
                  <button
                    className="btn btn-default w-100 m-0 mb-2"
                    value={cardEle?.isStatusEditTrue}
                    onClick={() => onChange(!cardEle?.isStatusEditTrue, 'isStatusEditTrue', cardIndex)}
                  >
                    <span className="icon-edit mr-2" />
                    {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.EDIT_COLOUR')}
                  </button>
                  {cardEle?.statusColoursOptions?.map((stat, keyIn) => {
                    return (
                      <>
                        <div
                          className="status-color-option"
                          onClick={() => onChange(stat, 'status', cardIndex)}
                          style={
                            cardEle?.status?.colourHexCode === stat?.colourHexCode
                              ? {
                                  border: '2px solid #8d8dff',
                                }
                              : {}
                          }
                        >
                          <div className="color-content">
                            <input
                              type="color"
                              className="form-control"
                              value={stat?.colourHexCode}
                              onChange={(e) => changeStatusArray(e, cardIndex, keyIn, 'colourHexCode')}
                              disabled={!cardEle?.isStatusEditTrue}
                            />
                          </div>
                          <input
                            type="text"
                            className="text-content f-14"
                            value={stat?.colourName}
                            placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ADD_COLOUR_NAME')}
                            onChange={(e) => changeStatusArray(e, cardIndex, keyIn, 'colourName')}
                            readOnly={!cardEle?.isStatusEditTrue}
                          />
                        </div>
                        <br />
                      </>
                    );
                  })}
                </div>
              </FormGroup>
              {cardEle.hasError && !cardEle?.status && (
                <span className="error-message position-absolute">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.PLEASE_SELECT_STATUS')}</span>
              )}
            </Col>
          )}
          {cardEle?.manualType?.key === 'Textbox' && (
            <Col lg="12" className="mb-3">
              <FormGroup className="m-0">
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    className="form-control f-14"
                    value={cardEle?.characterLimit}
                    placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ADD_CHARACTER_UNIT')}
                    onChange={(e) => {
                      if (checkIsNumber(e.target.value)) {
                        onChange(e.target.value, 'characterLimit', cardIndex);
                      }
                    }}
                  />
                  <label className="asterisk-req">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.CHARACTER_LIMIT')}</label>
                </div>
              </FormGroup>
              {cardEle.hasError && !cardEle?.characterLimit && (
                <span className="error-message position-absolute pb-3">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.CHARATER_LIMIT_REQUIRED')}</span>
              )}
            </Col>
          )}
        </>
      )
    );
  };

  return (
    <Modal onHide={toggle} show={open}>
      <Modal.Header>{`${editData ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.EDIT') : t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ADD')} ${
        editData ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ROW') : t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.NEW_ROW')
      }`}</Modal.Header>
      {modalState.loading ? (
        <Loader />
      ) : (
        <Modal.Body>
          {modalState.cards?.map((cardEle, cardIndex) => {
            return (
              <div className="d-flex" key={cardIndex}>
                <Card className="flex-fill">
                  <Row className="px-3">
                    <Col lg={12} className="mb-3">
                      <div className="input-group form-floating-label-po fixed-label">
                        <div className="input-group form-floating-label fixed-label">
                          <input
                            type="text"
                            name="RowName"
                            placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ENTER_ROW_NAME')}
                            value={cardEle?.name}
                            className="form-control f-14"
                            maxLength={30}
                            onChange={(e) => onChange(e?.target?.value, 'name', cardIndex)}
                          />
                          <label className="asterisk-req f-14 mb-0">
                            {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ROW_NAME')} <span>*</span>
                          </label>

                          <div className="text-count">{cardEle?.nameCount}/30</div>
                        </div>
                      </div>
                      {cardEle?.hasError && !cardEle?.name?.trim().length && (
                        <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.NAME_REQUIRED')}</span>
                      )}
                    </Col>
                    <Col lg={12} className="mb-3">
                      <label className="asterisk-req f-14 mb-0">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ASSIGNEE')}</label>
                      <Select
                        name="assignee"
                        options={modalState.asigneeList}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        maxMenuHeight={140}
                        isClearable
                        value={cardEle.assignee ? chcekingFromDynamicArray(modalState.asigneeList, cardEle?.assignee) : null}
                        styles={customStyles}
                        onChange={(e) => onChange(e, 'assignee', cardIndex)}
                        placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_ASSIHNEE')}
                      />
                    </Col>
                    <Col lg={12} className="mb-3">
                      <label className="asterisk-req f-14 mb-0">
                        {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ROW_TYPE')} <span>*</span>
                      </label>
                      <Select
                        name="rowType"
                        options={columTypeList}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        maxMenuHeight={140}
                        value={cardEle?.rowType ? chcekingFromDynamicArray(columTypeList, cardEle?.rowType) : null}
                        styles={customStyles}
                        isDisabled={editData}
                        onChange={(e) =>
                          onChange(e, 'rowType', cardIndex, false, null, [
                            'location',
                            'section',
                            'subLocation',
                            'type',
                            'subType',
                            'options',
                            'labelColoursOptions',
                            'status',
                            'statusColoursOptions',
                            'characterLimit',
                          ])
                        }
                        placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.SELECT_ROW_TYPE')}
                      />
                      {cardEle?.hasError && !cardEle?.rowType && (
                        <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ROW_TYPE_IS_REQUIRED')}</span>
                      )}
                    </Col>

                    {sourceOptions(cardEle, cardIndex)}
                    {manualOptions(cardEle, cardIndex)}
                  </Row>
                </Card>
                {!editData && modalState.cards?.length - 1 === cardIndex && OperationalAddEditAccess && (
                  <div className="btn-outline-container">
                    <BtnAdd onBtnClick={addCard} addEditAccess />
                  </div>
                )}
                {modalState.cards?.length > 1 && OperationalDeleteAccess && (
                  <div className="btn-outline-container">
                    <BtnDelete multiDelete={() => deleteCard(cardIndex)} />
                  </div>
                )}
              </div>
            );
          })}
          <div className="modal-buttons mt-5 d-flex justify-content-between">
            {OperationalAddEditAccess && (
              <button type="button" onClick={handleCancel} className="btn btn-default" disabled={isProductArchived}>
                {t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.CANCEL')}
              </button>
            )}
            {OperationalAddEditAccess && (
              <button type="button" onClick={handleSubmit} className="btn btn-default" disabled={isProductArchived}>
                {editData ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.UPDATE') : t('OPERATIONAL_CP.MODALS.ADD_EDIT_ROW.ADD')}
              </button>
            )}
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}

export default AddEditRow;
